/* eslint-disable react/no-unescaped-entities */
import React from "react";

export default function Privacy() {
    return (
        <div data-testid="privacy-page" className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12 py-24">
            <span className="overline">Legal</span>
            <h1 className="font-serif text-4xl sm:text-5xl font-bold mt-4 text-[#0A192F]">
                Privacy Policy
            </h1>
            <div className="mt-10 space-y-6 text-slate-700 leading-relaxed">
                <p>
                    Hopewell Consulting LLC ("we", "us", "our") respects your
                    privacy. This policy explains what we collect, why, and how
                    you can manage your information.
                </p>
                <h2 className="font-serif text-2xl font-bold text-[#0A192F] pt-4">
                    Information we collect
                </h2>
                <p>
                    When you contact us through this site we collect the name,
                    email, phone, organization, and project details you provide.
                    We use this only to respond to your inquiry and manage our
                    engagement with you.
                </p>
                <h2 className="font-serif text-2xl font-bold text-[#0A192F] pt-4">
                    How we use it
                </h2>
                <p>
                    Submissions are stored securely and accessed only by
                    authorized staff at Hopewell Consulting. We do not sell or
                    share your information with third parties for marketing.
                </p>
                <h2 className="font-serif text-2xl font-bold text-[#0A192F] pt-4">
                    Cookies & analytics
                </h2>
                <p>
                    The site uses essential cookies to operate. Analytics may
                    be added to understand site performance — these never
                    capture personal information.
                </p>
                <h2 className="font-serif text-2xl font-bold text-[#0A192F] pt-4">
                    Contact
                </h2>
                <p>
                    Questions about this policy? Email reico85@gmail.com or
                    call 865-951-8347.
                </p>
                <p className="text-sm text-slate-500 pt-6">
                    Last updated: {new Date().toLocaleDateString()}
                </p>
            </div>
        </div>
    );
}
